import { AvvirRoutingEvent } from "type_aliases";
import type { BackContext } from "../../models/domain/back_context";

export type ToProfilePageEvent = AvvirRoutingEvent<typeof TO_PROFILE_PAGE, { backContext?: BackContext }>

const toProfilePage = (backContext?: BackContext): ToProfilePageEvent => ({
  type: TO_PROFILE_PAGE,
  payload: { backContext }
});

export const TO_PROFILE_PAGE = "to_profile_page";

export default toProfilePage;
